// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles-modal__3Csv1","title":"styles-title__1p0hv","text":"styles-text__juZab","close":"styles-close__1qon9"};